import { defineMessages } from 'react-intl';

export const messages: {
	aiGenerationErrorFlagDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	aiGenerationErrorFlagDescriptionWithReason: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	aiGenerationErrorFlagTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	imageLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	imageLabel: {
		id: 'company-hub.company-hub-common.link-cards.card.image.section.label',
		defaultMessage: 'Image',
		description: 'Visible label for the section of the card for handling image',
	},
	aiGenerationErrorFlagTitle: {
		id: 'company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.title',
		defaultMessage: "We couldn't generate your image",
		description:
			'Title within the error flag when AI image generation fails for a Company Hub premium extension (Cards or Carousel).',
	},
	aiGenerationErrorFlagDescription: {
		id: 'company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description',
		defaultMessage: 'Try again or choose a different image.',
		description:
			'Description within the error flag when AI image generation fails for a Company Hub premium extension (Cards or Carousel).',
	},
	aiGenerationErrorFlagDescriptionWithReason: {
		id: 'company-hub.company-hub-common.link-cards.card.image.ai-generation.error.flag.description-with-reason',
		defaultMessage: '{errorReason}. Try again or choose a different image.',
		description:
			'Description within the error flag when AI image generation fails for a Company Hub premium extension with a specific error reason from the API.',
	},
});
